import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--breadcrumbs",
  "use": "icon-arrow--breadcrumbs-usage",
  "viewBox": "0 0 5 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5 8\" id=\"icon-arrow--breadcrumbs\"><path d=\"M3.947 1.057A.182.182 0 0 0 3.818 1a.172.172 0 0 0-.129.057L1.053 3.863A.195.195 0 0 0 1 4a.204.204 0 0 0 .053.137L3.69 6.943A.182.182 0 0 0 3.82 7a.172.172 0 0 0 .128-.057A.195.195 0 0 0 4 6.806a.204.204 0 0 0-.053-.137L1.44 4l2.507-2.67A.2.2 0 0 0 4 1.194a.2.2 0 0 0-.053-.136Z\" fill=\"#1C2646\" stroke=\"#1C2646\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol